import auth from '@/api/auth.js';

const authHeaders = () => ({ Authorization: 'Bearer ' + auth.getAuthHeader() });

export default {
  getCompany(http, sirketKodu) {
    return http.post(
      auth.API_URL + 'api/Parameters/CompanyGet',
      { SirketKodu: sirketKodu },
      { headers: authHeaders() }
    );
  },

  checkExtraProduct(http) {
    return http.post(
      auth.API_URL + 'api/Awed/ExtraProductGroupList',
      { GrupID: null, UrunID: null, MusteriID: null },
      { headers: authHeaders() }
    );
  },

  checkAgency(http, email, taxNo) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/CheckAgency',
      { Email: email, TaxNo: taxNo },
      { headers: authHeaders() }
    );
  },

  addAgency(http, firma) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/AddAgency',
      { ...firma, IsActive: true, CountryCode: 'TR' },
      { headers: authHeaders() }
    );
  },

  login(http, username, password) {
    return http.post(
      auth.BOOKING_API_URL + 'Login',
      { Username: username, Password: password, IsTest: false },
      { headers: authHeaders() }
    );
  },

  getCredentials(http, sessionHeader) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/GetCredential',
      { SessionHeader: sessionHeader },
      { headers: authHeaders() }
    );
  },

  addCredential(http, params) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/AddCredential',
      params,
      { headers: authHeaders() }
    );
  },

  editCredential(http, params) {
    return http.post(
      auth.BOOKING_API_URL + 'Agency/EditCredential',
      params,
      { headers: authHeaders() }
    );
  },

  searchLocation(http, sessionHeader, keyword, location = 'tr') {
    return http.post(
      auth.BOOKING_API_URL + 'Hotel/SearchLocation',
      {
        SessionHeader: sessionHeader,
        Key: keyword,
        Location: location
      },
      { headers: authHeaders() }
    );
  },

  searchHotels(http, payload, culture = 'tr-TR') {
    return http.post(
      auth.BOOKING_API_URL + 'Hotel/GetFilter',
      { ...payload, Culture: culture },
      { headers: authHeaders() }
    );
  },

  getHotelRooms(http, payload, culture = 'tr-TR') {
    return http.post(
      auth.BOOKING_API_URL + 'Hotel/GetFiltersFromCollaction',
      { ...payload, Culture: culture },
      { headers: authHeaders() }
    );
  },

  getProductInfo(http, payload, culture = 'tr-TR') {
    return http.post(
      auth.BOOKING_API_URL + 'Hotel/GetProductInfo',
      { ...payload, Culture: culture },
      { headers: authHeaders() }
    );
  },

  getReservationList(http, payload) {
    return http.post(
      auth.BOOKING_API_URL + 'Hotel/HotelReservationList',
      payload,
      { headers: authHeaders() }
    );
  },

  getReservationCancelPenalty(http, payload) {
    return http.post(
      auth.BOOKING_API_URL + 'Hotel/GetReservationCancelPenalty',
      payload,
      { headers: authHeaders() }
    );
  },

  cancelReservation(http, payload) {
    return http.post(
      auth.BOOKING_API_URL + 'Hotel/GetReservationCancel',
      payload,
      { headers: authHeaders() }
    );
  }

};
